import request from "@/utils/request";
import { foByGet } from "@/utils/common";
import qs from "qs"


export function getList(data) {
  return request({
    url: "gov_app_platform/api/item/getList",
    method: "post",
    data,
  });
}

export function createSign(data) {
  return request({
    url: "/jpaas-jags-server/interface/createsign",
    method: "post",
    data:qs.stringify(data),
  });
}
 
export function gateWay(data) {
  return request({
    url: "/jpaas-jags-server/interface/gateway",
    method: "post",
    data:qs.stringify(data),
  });
}
  